<template>
  <Modal v-model="openModal" draggable title="指令下发" footer-hide width="300">
    <Button @click="cut" type="primary">断开油电</Button>
    <Button @click="link" type="primary">恢复油电</Button>
    <Button @click="dianming" type="primary">位置点名</Button>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      openModal: false,
      item: {
        cmdType: "TTS文本消息",
        command: "{}",
        deviceIdList: [],
        msgid: "8300",
        cmdDesc: "显示屏显示",
        paramid: "1",
        cmdhead: "",
        init_mileage: 0,
        vno: "",
      },
    };
  },
  methods: {
    open(v) {
      this.openModal = true;
      this.item.deviceIdList=[v.deviceId];
    },
    cut() {
      this.item.cmdType = "油电控制";
      this.item.cmdDesc = "断开油电";
      this.item.msgid = "8105";
      this.item.paramid = "64";
      this.axios({
        method: "post",
        url: this.axios.cmd + "/record/send",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.openModal = false;
          this.$Message.success("下发成功");
        }
      });
    },
    link() {
      this.item.cmdType = "油电控制";
      this.item.cmdDesc = "恢复油电";
      this.item.msgid = "8105";
      this.item.paramid = "65";
      this.axios({
        method: "post",
        url: this.axios.cmd + "/record/send",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.openModal = false;
          this.$Message.success("下发成功");
        }
      });
    },
    dianming() {
      this.item.cmdType = "位置点名";
      this.item.cmdDesc = "位置点名";
      this.item.msgid = "8201";
      this.item.paramid = "1";
      this.axios({
        method: "post",
        url: this.axios.cmd + "/record/send",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.openModal = false;
          this.$Message.success("下发成功");
        }
      });
    },
    chepai() {
      this.item.cmdType = "设置车牌";
      this.item.cmdDesc = "设置车牌";
      this.item.msgid = "8103";
      this.item.paramid = "0083";
      this.axios({
        method: "post",
        url: this.axios.cmd + "/record/send",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.openModal = false;
          this.$Message.success("下发成功");
        }
      });
    },
  },
};
</script>
<style lang="">
</style>


// WEBPACK FOOTER //
// src/components/locate/com/zhiling.vue